import { render, staticRenderFns } from "./Primary.vue?vue&type=template&id=11a0d90a&scoped=true"
import script from "./Primary.vue?vue&type=script&lang=js"
export * from "./Primary.vue?vue&type=script&lang=js"
import style0 from "./Primary.vue?vue&type=style&index=0&id=11a0d90a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a0d90a",
  null
  
)

export default component.exports